import { useEffect, useLayoutEffect } from "react";
import { Outlet, useNavigate, useLocation, useNavigationType } from "react-router-dom";
import { AuthStatus, useAuthContext } from "../hooks/useAuthContext";

export function MainLayout() {
  const { checkAuthenticated, status } = useAuthContext()
  const navigate = useNavigate();
  const location = useLocation();
  const navigationType = useNavigationType();

  // Show the top of each new page; keep the position for query-only changes (filters, tabs) and browser back/forward.
  useLayoutEffect(() => {
    if (navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    checkAuthenticated()
  }, [checkAuthenticated])

  useEffect(() => {
    if (location.pathname !== '' && location.pathname !== '/') {
      return;
    }
    if (status === AuthStatus.UNKNOWN) {
      return;
    }
    if (status === AuthStatus.AUTHENTICATED) {
      navigate('/school', { replace: true });
      return;
    }
    navigate('/welcome', { replace: true });
  }, [location.pathname, navigate, status]);

  return (
    <>
      <Outlet />
    </>
  )
}